import React, { PropsWithChildren } from "react";
import toast from "react-hot-toast";
import { RWebShare } from "react-web-share";
import Icon from "../icons/icon";
import Share from "../icons/lib/share";
import { ClassProps } from "@/lib/types/class-props";
import { cx } from "@/lib/utils/className.utils";

export type ShareLinkSite =
  | "facebook"
  | "twitter"
  | "whatsapp"
  | "reddit"
  | "telegram"
  | "linkedin"
  | "mail"
  | "copy"
  | "vk"
  | "okru";

export type ShareLinkMobileModalProps = {
  title?: string;
  text?: string;
  url?: string;
  onShared?: (site: ShareLinkSite) => void;
} & PropsWithChildren &
  ClassProps;

const ShareLinkMobileModal = ({
  title = "Share",
  text = "Share link",
  url,
  onShared,
  children,
  className,
}: ShareLinkMobileModalProps) => {
  const handleShare = (site: ShareLinkSite) => {
    if (site === "copy") {
      toast.success("Link copied.");
    }
    onShared?.(site);
  };

  return (
    <RWebShare
      data={{
        text,
        url,
        title,
      }}
      onClick={handleShare}
    >
      {children ?? (
        <Icon
          id="button-share"
          icon={Share}
          className={cx("h-[20px] w-[20px] cursor-pointer", className)}
        />
      )}
    </RWebShare>
  );
};

export default ShareLinkMobileModal;
